import { createFactory } from 'react'

import Zalando from 'clients/Zalando'
import SketchRunner from 'clients/SketchRunner'
import Cookies from 'clients/Cookies'
import MarleySpoon from 'clients/MarleySpoon'
import Stylemarks from 'clients/Stylemarks'

export default [
  {
    description:
      'Find Europe’s largest selection of clothing, accessories and shoes online at Zalando.',
    name: 'Zalando',
    color: '#111111',
  // location: 'Berlin',
    logo: require('img/zalando/logo.svg'),
    loadComponent: createFactory(Zalando),
    order: 0,
    properties: { className: 'black' },
    slug: 'zalando',
    // appstore: '',
    // playstore: '',
    role: 'Freelance Designer',
    scope: 'Mobile Apps & Internal Tools',
    // stack: 'Rails, React, GraphQL',
    website: 'https://zalando.de',
  },
  {
    description:
      'Speed up your design workflow in Sketch with this plugin & run commands directly from your keyboard. Much wow.',
    name: 'Sketch Runner',
    duration: '2016 - currently',
    color: '#066CFF',
    // location: 'Wilmington, NC',
    logo: require('img/sketchrunner/logo.svg'),
    loadComponent: createFactory(SketchRunner),
    order: 1,
    properties: null,
    slug: 'sketchrunner',
    // appstore: '',
    // playstore: '',
    role: 'a bit of everything 🤓',
    // scope: 'Web, Mobile, Brand',
    // stack: 'Sketch, Github, Zeplin',
    website: 'https://sketchrunner.com',
  },
  {
    description:
      'A fintech startup with a different approach to deal with micropayments and peer-to-peer money transfer. Sweet!',
    duration: '2015',
    name: 'Cookies',
    color: '#00AFFF',
    // location: 'Berlin',
    logo: require('img/cookies/logo.svg'),
    loadComponent: createFactory(Cookies),
    order: 2,
    properties: null,
    slug: 'cookies',
    // appstore:
    //   'https://itunes.apple.com/us/app/cookies-hd-photos-from-iphone-gopro-or-snapchat/id670785096?mt=8',
    // playstore: '',
    role: 'Lead Designer',
    scope: 'Branding, mobile apps & web',
    // stack: '100% Sketch',
    // website: 'https://goo.gl/j6ZPG1 (kaputt)',
  },
  {
    description:
      'Receive the best local ingredients at home & prepare tasty recipes with instructions by their chefs.',
    duration: '2014 - 2015',
    name: 'Marley Spoon',
    color: '#2A2D35',
    // location: 'Chapel Hill, NC',
    logo: require('img/marleyspoon/logo.svg'),
    loadComponent: createFactory(MarleySpoon),
    order: 3,
    properties: null,
    slug: 'marleyspoon',
    // appstore: 'https://itunes.apple.com/us/app/marleyspoonme/id981886073?mt=8',
    // playstore: '',
    role: 'Product Designer',
    // scope: 'iOS, Brand',
    // stack: 'Sketch, Illustrator',
    website: 'http://marleyspoon.com',
  },
  {
    description:
      'A community driven marketplace mainly focused on design, vintage & handcrafted goodies. Absorbed by JUNIQUE. ',
    duration: '2013 - 2014',
    name: 'stylemarks.',
    color: '#ff6363',
    // location: 'Berlin',
    logo: require('img/stylemarks/logo.svg'),
    loadComponent: createFactory(Stylemarks),
    order: 4,
    properties: null,
    slug: 'stylemarks',
    // appstore: '',
    // playstore: '',
    role: 'UX/UI Designer',
    scope: 'iOS app, web, branding…',
    // stack: 'Sketch, Illustrator',
    website: '',
  },
  // client: {
  //   description: '',
  //   duration: '',
  //   name: '',
  //   order: '',
  //   properties: null,
  //   slug: '',
  //   appstore: '',
  //   playstore: '',
  //   role: '',
  //   scope: '',
  //   stack: '',
  //   website: '',
  // },
]

export const moreWork = [
  {
    img: 'gener8tor',
    href: 'http://gener8tor.com',
  },
  {
    img: 'optyn',
    href: 'https://optyn.com/',
  },
  {
    img: 'wemontage',
    href: 'http://wemontage.com',
  },
  {
    img: 'beekeeper',
    href: 'http://beekeeperdata.com',
  },
  {
    img: 'joyspace',
    href: 'https://angel.co/cookies-1',
  },
  {
    img: 'poparazzi',
    // href: '',
  },
  {
    img: 'sunsportmarine',
    // href: '',
  },
  {
    img: 'kioh',
    // href: '',
  },
]



// WEBPACK FOOTER //
// src/javascripts/utils/clients.js